function popupProducts() {
	// Alle Trigger-Elemente finden
	document.querySelectorAll('[id^="open-popup-"]').forEach(function (trigger) {

		// Klick-Events auf Links im Trigger verhindern
		trigger.querySelectorAll('a').forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
			});
		});

		// Klick-Event zum Öffnen des Popups
		trigger.addEventListener('click', function () {
			const id = this.id.replace('open-popup-', '');
			const popup = document.getElementById('popup-' + id);
			if (popup) {
				popup.classList.add('active'); // CSS Klasse zum Anzeigen
				document.body.classList.add('popup-open'); // optional fürs Scroll-Lock
			}
		});
	});

	// Optional: Schließen des Popups
	document.querySelectorAll('.product-popup-wrapper .close-btn').forEach(function (btn) {
		btn.addEventListener('click', function () {
			this.closest('.product-popup-wrapper').classList.remove('active');
			document.body.classList.remove('popup-open');
		});
	});
}

export {popupProducts};